import values from 'lodash/values';
import get from 'lodash/get';
import { createSelector } from '../utils';

var _getCollectionImageUrl = function _getCollectionImageUrl(collection) {
  var imageUrl;
  imageUrl = get(collection, ['image', 'url']);

  if ('imageLarge' in collection) {
    imageUrl = get(collection, ['imageLarge', 'url']);
  }

  return imageUrl;
};

var getCollections = function getCollections(_ref) {
  var collections = _ref.collections;
  return collections;
};

var getCollectionEntities = function getCollectionEntities(_ref2) {
  var entities = _ref2.entities;
  return values(entities).reverse();
};

var getMyCollections = function getMyCollections(collections) {
  return collections.filter(function (_ref3) {
    var canEdit = _ref3.canEdit;
    return canEdit;
  });
};

var getFollowedCollections = function getFollowedCollections(collections) {
  return collections.filter(function (_ref4) {
    var _ref4$followStatus = _ref4.followStatus,
        followStatus = _ref4$followStatus === void 0 ? {} : _ref4$followStatus;
    return !!followStatus.followedByYou;
  });
};

var formatCollections = function formatCollections(collections) {
  return collections.map(function (collection) {
    if (collection === void 0) {
      collection = {};
    }

    return {
      name: collection.name,
      eventCount: collection.eventCount,
      id: collection.id,
      href: "/c/" + collection.id,
      imageUrl: _getCollectionImageUrl(collection),
      followedByYou: get(collection, ['followStatus', 'followedByYou'], false)
    };
  });
};

export var getMyFormattedCollection = function getMyFormattedCollection(state) {
  return createSelector(getCollections, getCollectionEntities, getMyCollections, formatCollections)(state);
};
export var getFollowedFormattedCollections = function getFollowedFormattedCollections(state) {
  return createSelector(getCollections, getCollectionEntities, getFollowedCollections, formatCollections)(state);
};
export var getFormattedCollections = function getFormattedCollections(state) {
  return createSelector(getCollections, getCollectionEntities, formatCollections)(state);
};